export enum LeadEvents {
  CustomerCreated = 'lead.customer.Created',
  FunnelCreated = 'lead.funnel.Created',
  LeadCreated = 'lead.lead.Created'
}
